var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"segment__container"},_vm._l((_vm.steps),function(step){return _c('div',{staticClass:"segment",style:(_vm.getColor(step))})}))}
var staticRenderFns = []

export { render, staticRenderFns }